const BottomShape03 = () => {

    return (<div className="rmdr-bottom-shape-03" />)

}

export default BottomShape03;
